var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaWebsitesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ea-websites-icon_svg__a",
    d: "M0 60h67.636V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 36c0 13.255-10.746 24-24 24-13.255 0-24-10.745-24-24s10.745-24 24-24c13.254 0 24 10.745 24 24",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.909 38.182H6.545V3.272c0-1.205.977-2.181 2.182-2.181h48c1.206 0 2.182.976 2.182 2.182v34.909z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.909 37.09l-1.091 1.092h-5.455l-1.09-1.091H1.09a4.364 4.364 0 004.363 4.364h38.182V37.09H34.91z",
    fill: "#E74A10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.636 37.091H5.455V3.273A3.276 3.276 0 018.727 0h48A3.276 3.276 0 0160 3.273V12h-2.182V3.273c0-.602-.49-1.09-1.09-1.09h-48c-.602 0-1.092.488-1.092 1.09v33.818z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.636 42.546H5.455A5.46 5.46 0 010 37.09v-1.09h27.724l1.091 1.09h4.552l1.09-1.09h9.18v2.181H35.36l-1.091 1.091h-6.358l-1.09-1.09H2.367a3.279 3.279 0 003.087 2.181h38.181v2.182z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.363 14.182H48a2.181 2.181 0 00-2.182 2.182v34.909c0 1.204.976 2.182 2.182 2.182h16.363a2.182 2.182 0 002.182-2.182v-34.91a2.181 2.181 0 00-2.182-2.181",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 15.273c-.601 0-1.09.489-1.09 1.091v34.91c0 .601.489 1.09 1.09 1.09h16.364c.6 0 1.09-.489 1.09-1.09v-34.91c0-.602-.49-1.09-1.09-1.09H48zm16.364 39.273H48a3.277 3.277 0 01-3.273-3.273V16.364A3.277 3.277 0 0148 13.091h16.364a3.277 3.277 0 013.272 3.273v34.91a3.277 3.277 0 01-3.272 3.272z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ea-websites-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-websites-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#ea-websites-icon_svg__b)",
    d: "M54.545 51.273h3.273V49.09h-3.273z"
  }))));
}
export default SvgEaWebsitesIcon;